import { gql } from '@apollo/client'

export const Query = gql`
  query EventStages(
    $companyId: ID!,
    $eventId: ID!,
    $filters: EventStageFilters,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    events(companyId: $companyId, filters: { idEq: $eventId }, first: 1) {
      nodes {
        id
        eventStages(filters: $filters, after: $after, before: $before, first: $first, last: $last) {
          nodes {
            id
            name
            notes
          }
          pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
        }
      }
    }
  }
`
